import React from 'react';

function Messages(props) {
    const className = props.className;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 66.145836 66.145836"
            className={className}
        >
            <defs>
                <linearGradient id="messages-svg-grad" x1="-25.272568" y1="207.52057" x2="-25.272568" y2="152.9982" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0.98209275,0,0,0.98209275,-1.0651782,3.7961838)">
                    <stop offset="0" stopColor="#0cbd2a" />
                    <stop offset="1" stopColor="#5bf675" />
                </linearGradient>
            </defs>
            <g transform="translate(59.483067,-145.8456)">
                <rect
                    x="-59.483067"
                    y="145.8456"
                    width="66.145836"
                    height="66.145836"
                    rx="14.567832"
                    ry="14.567832"
                    fill="url(#messages-svg-grad)"
                />
                <path
                    fill="#ffffff"
                    d="m -26.410149,157.29606 a 24.278298,20.222157 0 0 0 -24.278105,20.22202 24.278298,20.222157 0 0 0 11.79463,17.31574 27.365264,20.222157 0 0 1 -4.245218,5.94228 23.85735,20.222157 0 0 0 9.86038,-3.87367 24.278298,20.222157 0 0 0 6.868313,0.83768 24.278298,20.222157 0 0 0 24.2781059,-20.22203 24.278298,20.222157 0 0 0 -24.2781059,-20.22202 z"
                />
            </g>
        </svg>
    );
}

export default Messages;
